import { Link } from "react-router-dom";
export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="sect-navy pt-32 pb-24 min-h-screen">
      <div className="bcu-container max-w-3xl">
        <p className="bcu-eyebrow">404</p>
        <h1 className="mt-5 text-5xl md:text-7xl font-display leading-[1.02]">Page not <span className="text-[#F7931E]">found.</span></h1>
        <p className="mt-6 text-[#C7CFDD]">The page you're looking for does not exist or has moved.</p>
        <Link to="/" className="mt-10 inline-flex bcu-btn-primary">Return to home</Link>
      </div>
    </div>
  );
}
